class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    
    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }
    
    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${this.currentVariant.featured_media.id}`)
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management || variantInventoryObject.policy === 'continue') {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.policy === 'continue') {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(false);
        
        return;
      }

      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--low');
      this.productInventoryNode.classList.remove('inventory-status--sold-out');

      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
        
      this.productInventoryNode.classList.remove('hide');
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.remove('inventory-status--low', 'inventory-status--sold-out');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
      this.productInventoryNode.classList.remove('hide');
    } else {
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.classList.remove('hide');
    }
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (buyBarInfoSource && destinationBuyBarInfo) {
          destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    
    const personalizeBtn = productForm.querySelector('.product-form__personalize');
    if (personalizeBtn && this.currentVariant) {
      const personalizePrice = parseFloat(personalizeBtn.dataset.price);
      const variantPrice = parseFloat(this.currentVariant.price);
      const priceDiff = personalizePrice - variantPrice;
      const priceDiffMoney = Woolman.Utils.formatMoney(priceDiff);

      if (priceDiff > 0) {
        personalizeBtn.textContent = window.variantStrings.personalize_for_price.replace('{{ money }}', priceDiffMoney);
      } else {
        personalizeBtn.textContent = window.variantStrings.personalize;
      }
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Store product handles to history for "recently-viewed" section.
(function() {
  const history = sessionStorage.getItem('Woolman_Product_History') ? sessionStorage.getItem('Woolman_Product_History').split(',') : [];
  const productHandle = window.location.pathname.split('/').pop();
  if (!productHandle) return;
  if (!history.includes(productHandle)) {

    if (history.length >= 10) { // only store up to 10 recently viewed products
      history.shift();
    }
    
    history.push(productHandle);
    sessionStorage.setItem('Woolman_Product_History', history.join(','));
  }
})();

if (!customElements.get('product-buy-bar')) {
  customElements.define('product-buy-bar', class ProductBuyBar extends HTMLElement {
    constructor() {
      super();

      this.primaryButtonHasBeenSeen = false;
      this.primaryButtonPassed = false;
      this.footerInView = false;
      this.handlePrimaryButtonClick = this.handlePrimaryButtonClick.bind(this);
      this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);
      this.observeFooter = this.observeFooter.bind(this);
      this.syncWithPrimaryButton = this.syncWithPrimaryButton.bind(this);
    }

    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.primaryButton = document.getElementById(`${this.dataset.formId}-submit`);
      this.submitButton = this.querySelector('[data-product-buy-bar-submit]');
      this.mobileQuery = window.matchMedia('(max-width: 767px)');

      if (!this.form || !this.primaryButton || !this.submitButton) {
        this.hide();
        return;
      }

      this.submitButton.addEventListener('click', this.handlePrimaryButtonClick);
      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.handleMediaQueryChange);
      } else {
        this.mobileQuery.addListener(this.handleMediaQueryChange);
      }

      this.primaryButtonObserver = new IntersectionObserver(([entry]) => {
        this.primaryButtonPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        this.updateVisibility();
      }, { threshold: 0 });
      this.primaryButtonObserver.observe(this.primaryButton);

      this.observeFooter();
      if (!this.footerObserver) {
        document.addEventListener('DOMContentLoaded', this.observeFooter, { once: true });
      }

      this.primaryButtonMutationObserver = new MutationObserver(this.syncWithPrimaryButton);
      this.primaryButtonMutationObserver.observe(this.primaryButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      this.syncWithPrimaryButton();
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.submitButton?.removeEventListener('click', this.handlePrimaryButtonClick);
      document.removeEventListener('DOMContentLoaded', this.observeFooter);
      if (this.mobileQuery?.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.handleMediaQueryChange);
      } else {
        this.mobileQuery?.removeListener?.(this.handleMediaQueryChange);
      }
      this.primaryButtonObserver?.disconnect();
      this.footerObserver?.disconnect();
      this.primaryButtonMutationObserver?.disconnect();
    }

    observeFooter() {
      if (this.footerObserver) return;

      const siteFooter = document.querySelector('footer.footer');
      if (!siteFooter) return;

      this.footerObserver = new IntersectionObserver(([entry]) => {
        this.footerInView = entry.isIntersecting;
        this.updateVisibility();
      }, { threshold: 0 });
      this.footerObserver.observe(siteFooter);
    }

    handlePrimaryButtonClick(event) {
      event.preventDefault();
      if (this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true') return;

      this.primaryButton.click();
    }

    handleMediaQueryChange() {
      this.updateVisibility();
      this.syncWithPrimaryButton();
    }

    isMobile() {
      return this.mobileQuery?.matches ?? window.innerWidth < 768;
    }

    updateVisibility() {
      const shouldShow = this.isMobile() && this.primaryButtonPassed && !this.footerInView;
      this.classList.toggle('show', shouldShow);
      this.setAttribute('aria-hidden', String(!shouldShow));

      if (shouldShow) {
        this.removeAttribute('inert');
        this.submitButton?.removeAttribute('tabindex');
      } else {
        this.setAttribute('inert', '');
        this.submitButton?.setAttribute('tabindex', '-1');
      }
    }

    hide() {
      this.classList.remove('show');
      this.setAttribute('aria-hidden', 'true');
      this.setAttribute('inert', '');
      this.submitButton?.setAttribute('tabindex', '-1');
    }

    syncWithPrimaryButton() {
      if (!this.primaryButton || !this.submitButton) return;

      const sourceLabel = this.primaryButton.querySelector('span');
      const targetLabel = this.submitButton.querySelector('[data-product-buy-bar-label]');
      const sourceSpinner = this.primaryButton.querySelector('.loading-overlay__spinner');
      const targetSpinner = this.submitButton.querySelector('.loading-overlay__spinner');
      const isDisabled = this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true';

      this.submitButton.toggleAttribute('disabled', isDisabled);
      this.submitButton.classList.toggle('loading', this.primaryButton.classList.contains('loading'));
      this.submitButton.classList.toggle('btn--primary', this.primaryButton.classList.contains('btn--primary'));
      this.submitButton.classList.toggle('btn--secondary', this.primaryButton.classList.contains('btn--secondary'));

      if (sourceLabel && targetLabel) targetLabel.textContent = sourceLabel.textContent;
      if (sourceSpinner && targetSpinner) {
        targetSpinner.classList.toggle('hidden', sourceSpinner.classList.contains('hidden'));
      }
    }
  });
}

class UpsellProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          //debugger
          const recommendations = html.querySelector('upsell-product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('upsell-product-recommendations', UpsellProductRecommendations);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);
